const routes = [{
  path: '/management',
  component: () => import('@/views/management'),
  name: 'management',
  meta: {
    title: '内容管理'
  }
}, {
  path: '/managementissue',
  component: () => import('@/views/management/managementissue'),
  name: 'management-issue',
  meta: {
    title: '文章发布'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/management.js